'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isString;
function isString(maybe) {
  return typeof maybe === 'string';
}